<template>
    <dashboard>
        <row v-if="school">
            <panel size="col-15">
                <h2 slot="title">School</h2>
                <div slot="buttons">
                    <app-button v-if="role <= 1" size="small" @click="handleCreateSchool">Add School</app-button>
                </div>
                <school-edit-view v-model="school"/>
            </panel>
            <panel size="col-9">
                <h3 slot="title">Closures</h3>
                <div slot="buttons">
                    <app-button
                        v-if="role <= 2"
                        size="small"
                        @click="handleCreateClosure">Add Closure</app-button>
                </div>
                <el-table :data="closures" style="width: 100%" empty-text="No Closures">
                    <el-table-column prop="title" label="Title"/>
                    <el-table-column prop="date" label="Dates">
                        <template slot-scope="scope">
                            {{ scope.row.start_date | moment("MM/DD/YYYY") }}
                            - {{ scope.row.end_date | moment("MM/DD/YYYY") }}
                        </template>
                    </el-table-column>
                </el-table>
            </panel>
        </row>

        <modal v-model="showAddSchool">
            <h3>Add School</h3>
            <school-edit-view v-model="emptySchool"/>
        </modal>

        <modal v-model="showAddClosure" size="small">
            <closure-edit-view/>
        </modal>
    </dashboard>
</template>

<script>
import { mapGetters } from 'vuex'
import School from '@/store/models/School'

import SchoolEditView from './SchoolEditView'
import ClosureEditView from './ClosureEditView'

export default {
    name: 'page-school',
    components: {
        SchoolEditView,
        ClosureEditView
    },
    head: {
        title: {
            inner: 'School'
        }
    },
    data() {
        return {
            isSaving: false,
            school: {},
            emptySchool: new School,
            showAddSchool: false,
            showAddClosure: false
        }
    },
    computed: {
        ...mapGetters(['role', 'user']),
        closures() { 
            if (!this.school.id) return []
            return School.query()
                .withAll()
                .find(this.school.id)
                .closures || []
        }
    },
    mounted() {
        this.school = School.find(this.user.school_id)
        School.$fetchOne()
            .then(({ data }) => {
                this.school = School.$cloneOrNew(data.id)
            })
    },
    methods: {
        handleCreateSchool() {
            this.emptySchool = {
                timezone: '',
                allow_user_invite: true
            }
            this.showAddSchool = true
        },
        handleCreateClosure() {
            this.showAddClosure = true
        }
    }
}
</script>

<style lang="stylus"></style>
